import React from 'react';
import { cn } from '../../src/lib/utils';
type ExampleFrameProps = {
  title: string;
  subtitle?: string;
  /** Visible label marking the content as fictional. */
  label?: string;
  caption?: string;
  children: React.ReactNode;
  className?: string;
};

/** Product-style panel used for every fictional example visual. */
export function ExampleFrame({
  title,
  subtitle,
  label = 'Illustrative example',
  caption,
  children,
  className
}: ExampleFrameProps) {
  return <figure className={cn('overflow-hidden rounded-2xl border border-hairline bg-panel text-left shadow-[0_40px_100px_-50px_rgba(20,14,60,0.55)]', className)} data-id="element-191" data-mp="25d6km115xcqp">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-hairline bg-surface px-4 py-3 sm:px-5" data-id="element-192" data-mp="1wgnsus4o3uvp">
        <div className="min-w-0" data-id="element-193" data-mp="kymq9u94oxl0">
          <p className="truncate text-sm font-semibold text-text-primary" data-id="element-194" data-mp="kyd128vwqugd">{title}</p>
          {subtitle ? <p className="truncate text-xs text-text-tertiary" data-id="element-195" data-mp="p1j0awklrldc">{subtitle}</p> : null}
        </div>
        <span className="shrink-0 rounded-md bg-[#FDF3E7] px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.06em] text-[#9A5B13]" data-id="element-196" data-mp="2cd0rxtzn3nsp">{label}</span>
      </div>
      <div className="p-4 sm:p-5" data-id="element-197" data-mp="2lcnx8qvhpdr1">{children}</div>
      {caption ? <figcaption className="border-t border-hairline-soft px-4 py-3 text-xs text-text-tertiary sm:px-5" data-id="element-198" data-mp="2le8mq22y66i1">{caption}</figcaption> : null}
    </figure>;
}